import plugin from './dist/vue-textarea-autosize.common.js'
export default plugin
export * from './dist/vue-textarea-autosize.common.js'



//////////////////
// WEBPACK FOOTER
// ./~/vue-textarea-autosize/index.js
// module id = 171
// module chunks = 88